import {
    Headings,
    Button,
    Image,
    Paragraph,
    ChatMinimizeIcon,
} from '@sentara-health/optimahealth_web';
import { useTranslation } from 'react-i18next';
import hingeHealthImg from '../../assets/images/hinge_health_img.svg';
import { useNavigate } from 'react-router-dom';
import { NavigateConst, navigateToExternalUrl } from 'common';
import { useContext } from 'react';
import { GlobalContext } from 'context';

function HingeHealth() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { ssoEndPoints } = useContext(GlobalContext);

    const handleButtonClick = () => {
        navigate(NavigateConst.dashboard);
    }

    const openHigneHealth = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        navigateToExternalUrl(ssoEndPoints?.hingeHealthURL);
    }

    return (
        <div>
            <Button
                iconLeft={<ChatMinimizeIcon />}
                data-testid="back"
                variant="icon_btn"
                onClick={handleButtonClick}
                aria-label={t('hingeHealth.backButton') ?? 'Back'}
            >
                {t('hingeHealth.title')}
            </Button>
            <div className="row py-4">
                <div className="col-md-6">
                    <Image
                        data-testid="hingeHealthImage"
                        className="rounded-top-4 w-100"
                        path={hingeHealthImg}
                    />
                </div>
                <div className="d-flex flex-column col-md-6 mt-3 mt-md-0">
                    <Headings
                        level={3}
                        text={t('hingeHealth.title')}
                        variant="semiBold"
                        dataTestId="physicalTherapyHeaderLabel"
                    />
                    <Paragraph text={t('hingeHealth.copayVirtualOnly')} variant="regular" dataTestId="hingeHealthLabel" className="text-muted" />
                    <Paragraph text={t('hingeHealth.hingeHealthHeadingContent')} variant="regular" dataTestId="hingeHealthHeadingContent" className="mt-2" />
                    <div className="d-flex align-items-center mt-1">
                        <Button
                            className="btn virtual-visit-button-style"
                            data-testid="hingeHealthSignUpButton"
                            variant="primary_btn"
                            onClick={(event: React.MouseEvent<HTMLButtonElement>) => openHigneHealth(event)}
                        >
                            {t('common.signUp')}
                        </Button>
                    </div>
                </div>
            </div>
            <div className="d-flex flex-column mt-2">
                <Headings
                    level={5}
                    text={t('hingeHealth.whatWeOffer')}
                    variant="bold"
                    data-testid="hingeHealthHeader"
                />
                <Paragraph text={t('hingeHealth.whatWeOfferContent')} variant="regular" dataTestId="hingeHealthContent" />
                <ul className="custom-list ms-2">
                    <li>
                        <span className="fw-bold">{t('hingeHealth.dedicatedPhysicalTherapist')}</span>
                        <span className="font-size-16 ms-1">
                            {t('hingeHealth.dedicatedPhysicalTherapistContent')}
                        </span>
                    </li>
                    <li>
                        <span className="fw-bold">{t('hingeHealth.personalizedExerciseSessions')}</span>
                        <span className="font-size-16 ms-1">
                            {t('hingeHealth.personalizedExerciseSessionsContent')}
                        </span>
                    </li>
                </ul>
            </div>
            <span className="font-size-16 ms-1 italic-style">
                {t('hingeHealth.valueAddedProgramContent')}
            </span>
            <br />
            <span className="font-size-16 ms-1 italic-style">
                {t('hingeHealth.noObligationAndTheServicesContent')}
            </span>
        </div>
    );
}

export default HingeHealth;